import { ReactNode } from "react";

interface AdminPageHeaderProps {
  title: string;
  action?: ReactNode;
}

/**
 * Sits at the top of an .admin-page's flex column (see AdminLayout.css):
 * since only .admin-page-body below it scrolls, this stays in view without
 * needing position: sticky.
 */
const AdminPageHeader = ({ title, action }: AdminPageHeaderProps) => (
  <div className="admin-page-header">
    <h1 className="admin-page-title">{title}</h1>
    {action && <div className="admin-page-header-action">{action}</div>}
  </div>
);

export default AdminPageHeader;
